import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68eebdf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content__page"
}
const _hoisted_2 = { class: "content__page--upper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "content__page--lower" }
const _hoisted_6 = {
  key: 1,
  class: "content__page"
}
const _hoisted_7 = { class: "content__page--full" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentPage',
  props: {
  full: {
    type: Boolean,
    required: false,
    default: false,
  },
  wideHr: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (!__props.full)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "upper")
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([{ wide: __props.wideHr }, "hr-wrapper"])
        }, _hoisted_4, 2),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "lower")
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "full")
        ])
      ]))
}
}

})